import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SpinnerService {
  spinnerObj = new BehaviorSubject<boolean>(false);
  spinner$ = this.spinnerObj.asObservable();

  paginationSpinnerObj = new BehaviorSubject<boolean>(false);
  paginationSpinner$ = this.spinnerObj.asObservable();

  constructor() {}


  // general spinner
  startSpinner(): void {
    this.spinnerObj.next(true);
  }

  stopSpinner(): void {
    this.spinnerObj.next(false);
  }


  // spinner of paginators on request-page
  startPaginationSpinner(): void{
    this.paginationSpinnerObj.next(true);
  }

  stopPaginationSpinner(): void{
    this.paginationSpinnerObj.next(false);
  }
}
